import { render, staticRenderFns } from "./DepositVoucherCandle.vue?vue&type=template&id=79f71ff1&"
import script from "./DepositVoucherCandle.vue?vue&type=script&lang=js&"
export * from "./DepositVoucherCandle.vue?vue&type=script&lang=js&"
import style0 from "./DepositVoucherCandle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports